// extracted by mini-css-extract-plugin
export default {"link":"NavButton_link__O16vj","active":"NavButton_active__qCYdl"};